<div class="rms-form-field" [class.no-margin]="noMargin">
  <label *ngIf="hasLabel" class="rms-label">
    {{ label }}
  </label>

  <div class="range-container" [class.disabled]="disabled">
    <input type="range"
           [min]="min"
           [max]="max"
           [step]="step"
           [disabled]="disabled"
           [ngModel]="value ?? min"
           (ngModelChange)="onSliderInput($event)"
           (blur)="onBlur()" />

    <div class="input-row" *ngIf="showInput">
      <input type="number"
             class="slider-number-input"
             [min]="min"
             [max]="max"
             [step]="step"
             [disabled]="disabled"
             [ngModel]="rawInput"
             (ngModelChange)="onNumberInput($event)"
             (blur)="onBlur()" />
    </div>

    <div class="label-container">
      <span>{{ min }}</span>
      @if(!showInput){<span class="current-value">{{ value ?? '-' }}</span>}
      <span>{{ max }}</span>
    </div>
  </div>

  <div class="rms-error" *ngIf="invalid">
    {{ errorMessage }}
  </div>
</div>
